// used by cph-epi\src\Cph.Website\Views\Blocks\AnnouncementNotificationBlock.cshtml

function AnnouncementBanner() {
  const elems = document.querySelectorAll(".notifications")
  if (elems && elems.length > 0) {
    elems.forEach((element) => {
      const version = element.dataset.notificationVersion
      const match = RegExp(new RegExp("(^| )" + version + "=([^;]+)")).exec(document.cookie)
      if (!match) {
        element.style.display = "block"
      }
    })
  }
}

AnnouncementBanner()
